import { render, staticRenderFns } from "./prescription-detail.vue?vue&type=template&id=1c1a1b86&scoped=true"
import script from "./prescription-detail.vue?vue&type=script&lang=js"
export * from "./prescription-detail.vue?vue&type=script&lang=js"
import style0 from "./prescription-detail.vue?vue&type=style&index=0&id=1c1a1b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a1b86",
  null
  
)

export default component.exports